
import { mapState, mapGetters } from 'vuex'
import baseLogic from '~/mixins/base-logic'

export default {
    mixins: [baseLogic],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            steppers: 1,
            selectedBank: 1,
            remainingTime: {
                minutes: 14,
                seconds: 5,
            },
            pModel: 0,
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
        ...mapGetters({
            depositInstruction: 'cms/depositInstruction',
            loading: 'themes/company-bank/loading',
            companyBankAccounts: 'themes/company-bank/companyBankAccount',
            playerPrimaryBankAccount: 'themes/player-bank/primaryBankAccount',
        }),
    },
    async mounted() {
        const params = { currency: this.$cookie.get('player')?.currency }
        await this.$store.dispatch(
            'themes/company-bank/getCompanyBankPlayerAccount',
            params
        )
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    methods: {
        copiedBankId(item) {
            try {
                setTimeout(() => {
                    this.copyAndOpenApp(item?.bank_account_number)
                }, 300)
                const playerBankAccountNumber = document.getElementById(
                    'playerBankAccountNumber'
                )
                navigator.clipboard.writeText(playerBankAccountNumber.innerText)
            } catch (error) {}
        },
    },
}
